import {
  Swiper, Navigation, Autoplay, Pagination,
} from 'swiper';

Swiper.use([Navigation, Autoplay, Pagination]);

const setCurrent = (snapIndex) => {
  const currentNum = document.querySelector('.gallery_slider_current');
  const num = snapIndex + 1 < 10 ? `0${snapIndex + 1}` : snapIndex + 1;
  currentNum.textContent = num;
};

if (document.querySelector('.gallery_slider .swiper-container')) {
  // eslint-disable-next-line no-new
  new Swiper('.gallery_slider .swiper-container', {
    loop: false,
    speed: 800,
    slidesPerView: 1,
    spaceBetween: 15,
    on: {
      activeIndexChange: ({ snapIndex }) => setCurrent(snapIndex),
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.gallery_slider .button_circle--next',
      prevEl: '.gallery_slider .button_circle--prev',
      disabledClass: 'button--disabled',
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
      1024: {
        spaceBetween: 25,
        slidesPerView: 2,
      },
    },
  });
}
